/** 场景专用部署指南（PRD 模块二） */

export interface ScenarioGuideItem {
  slug: string
  title: string
  subtitle: string
  skills: { name: string; desc: string }[]
  security?: string
  content: string[]
  code?: string
}

export const SCENARIO_GUIDES: ScenarioGuideItem[] = [
  {
    slug: 'developer',
    title: '全自动代码与运维助手 (Developer/DevOps)',
    subtitle: 'GitHub、Vercel、n8n 等自动化',
    skills: [
      { name: 'GitHub', desc: '自动 Review PR / 提 Issue' },
      { name: 'Vercel', desc: '自动部署' },
      { name: 'n8n Workflow', desc: '自动化流' },
    ],
    security: '建议在 Docker 中开启 sandbox.mode: "all"（完全沙盒），配置 tools.elevated 进行权限审批，以防 AI 误删系统文件。',
    content: [
      '在 openclaw.json 中启用 GitHub、Vercel、n8n 等 skill。',
      '配置对应 API Token（GITHUB_TOKEN、Vercel 等），不要提交到公网仓库。',
      '使用 TUI 或 Slack/Telegram 通道下发指令，如「请 review 仓库 xxx 的 PR #42」。',
      '沙盒模式下敏感文件操作会要求确认，请勿关闭 elevated 审批。',
    ],
    code: `# 示例：仅作结构参考，密钥勿提交
# openclaw.json 片段
# skills: ["github", "vercel", "n8n"]
# sandbox.mode: "all"
# tools.elevated: true`,
  },
  {
    slug: 'enterprise',
    title: '国内企业协同办公助理 (Enterprise Workspace)',
    subtitle: '飞书官方插件部署',
    skills: [
      { name: '飞书插件', desc: 'im:message 等机器人权限' },
    ],
    content: [
      '在飞书开放平台创建应用，申请 im:message、联系人等权限。',
      '配置长链接（WebSocket）地址，指向你部署的 OpenClaw gateway。',
      '在 OpenClaw 中启用飞书 channel，填写 App ID、App Secret 等。',
      '使用 /feishu start 唤醒机器人。推荐模型：Kimi (Moonshot) 或 DeepSeek，中文体验好、成本低。',
    ],
    code: `# 飞书 channel 配置示例（脱敏）
# channels:
#   - type: feishu
#     app_id: xxx
#     app_secret: xxx
# 模型示例：kimi / deepseek`,
  },
  {
    slug: 'research',
    title: '深度信息检索与私人大脑 (Research & Second Brain)',
    subtitle: 'Obsidian、Firecrawl、Exa',
    skills: [
      { name: 'Obsidian Direct', desc: '连接本地知识库' },
      { name: 'Firecrawl MCP', desc: '全网深度抓取与结构化提取' },
      { name: 'Exa Search', desc: '开发者专用搜索' },
    ],
    content: [
      'OpenClaw 使用混合检索（BM25 + 向量），可更好利用 MEMORY.md 与本地知识库。',
      '定期维护 MEMORY.md 与 Obsidian vault，避免 AI 遗忘重要上下文。',
      'Firecrawl 用于深度抓取与结构化；Exa 适合代码与技术检索。',
    ],
  },
  {
    slug: 'smart-home',
    title: '智能家居中枢 (Smart Home)',
    subtitle: 'Home Assistant CLI',
    skills: [
      { name: 'Home Assistant CLI', desc: '局域网内控灯、控温' },
    ],
    content: [
      '在运行 OpenClaw 的机器上配置 Home Assistant 的访问（本地 URL + Long-Lived Access Token）。',
      '安装并启用 Home Assistant CLI skill，确保与 HA 在同一局域网。',
      '通过自然语言指令如「把客厅灯打开」「把温度调到 22 度」控制设备。',
    ],
  },
]

export function getGuideBySlug(slug: string): ScenarioGuideItem | undefined {
  return SCENARIO_GUIDES.find((g) => g.slug === slug)
}
